<template>
  <v-dialog
    v-model="show"
    persistent
    max-width="500"
    eager
    v-if="selectedInclusion"
  >
    <v-card :loading="updatePlanLoadingDialog">
      <v-card-title class="justify-space-between">
        Add {{ selectedInclusion.name }} to your plan?
        <v-btn fab text small @click="$emit('close')"
          ><v-icon class="text-right text--secondary">close</v-icon></v-btn
        >
      </v-card-title>
      <v-card-text>
        <p v-if="selectedInclusion.name">
          You can start using {{ selectedInclusion.name }} today and we will
          adjust the price accordingly in your next billing.
        </p>

        <v-row class="pb-0">
          <v-col class="pt-5 pb-0" v-if="selectedInclusion.name">
            <v-btn
              large
              elevation="0"
              color="primary"
              block
              @click="handleAddMCToPlan"
            >
              Add {{ selectedInclusion.name }} to my plan
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import {getHttpsCallable} from "@/shared/firebase_utils";

export default {
  props: {
    selectedInclusion: { type: Object, default: null },
    show: { type: Boolean, default: false },
  },
  data() {
    return {
      updatePlanLoadingDialog: false,
    };
  },
  computed: {
    ...mapGetters(["businessProfile"]),
  },
  methods: {
    ...mapActions(["showSnackbar", "updateBusinessProfileDetails"]),
    async handleAddMCToPlan() {
      //This method should switch a grow plan to evolve plan
      await this.changeSubscriptionPlan("evolve");
      this.$emit("close");
      //   this.showAddToPlanDialog = false;
      this.showSnackbar({
        show: true,
        text: "EventConnect added to plan successfully!",
      });
    },
    async changeSubscriptionPlan(plan) {
      console.log("changeSubscriptionPlan");
      if (this.updatePlanLoadingDialog) return;
      try {
        this.updatePlanLoadingDialog = true;
        const changeSubscriptionPlan = getHttpsCallable("changeSubscriptionPlan");
        const response = await changeSubscriptionPlan({
          subscriptionId: this.businessProfile.subscriptionId,
          billingPeriod: this.businessProfile.billingPeriod,
          plan: plan,
          quantity: this.businessProfile.noOfEmployees,
        });
        if (response.data.error != undefined) {
          console.log(
            "Error while calling the changeSubscriptionPlan cloud function"
          );
          console.log(response.data.error);
        } else {
          const subscription = response.data;
          if (
            subscription.status === "active" ||
            subscription.status === "trialing" ||
            subscription.status === "past_due"
          ) {
            //Update the Business Profile
            console.log(subscription);
            await this.updateBusinessProfileDetails({
              subscriptionStatus: subscription.status,
              plan: plan,
            });
          }
        }
        this.updatePlanLoadingDialog = false;
      } catch (error) {
        this.updatePlanLoadingDialog = false;
        console.log(error);
      }
    },
  },
};
</script>

<style>
</style>